const _ = require("lodash");
const {findArguments, findOptionalArgument} = require("../util/ParserHelpers");
const {basicDrawNodeImage, critterInfo} = require("../util/RenderHelpers");
const {getButton} = require("../../util/AssetsUtil");

const commandData = {
	critter: {
		parserDataFunc: function(ps) {
			const critterNames = _.keys(critterInfo);
			const args = findArguments(ps, 1);
			if (!args) {
				return false;
			}
			const name = args[0].getRest().toLowerCase();
			if (!_.includes(critterNames, name)) {
				ps.pushError(
					name +
						" is not a valid critter nickname. Possible names are the following: " +
						critterNames.join(", ") +
						"."
				);
				return false;
			}
			return {name};
		},
		measureFunc: function(rc, fontInfo, props, node) {
			const info = critterInfo[node.name];
			const imgSrc =
				global.BASE_URL + "assets/images/problem-art/critters/" + info.img;
			const ratio = info.ratio;
			const height = props.sizeScaleFactor * 30;
			const width = height / ratio;
			return {
				width: width,
				top: height / 2,
				bottom: height / 2,
				fontInfo,
				imgSrc,
			};
		},
		readAloudText: "",
	},
	dice: {
		parserDataFunc: function(ps) {
			const args = findArguments(ps, 1);
			if (!args) {
				return false;
			}
			const num = parseInt(args[0].getRest());
			if (!_.includes(_.range(1, 7), num)) {
				ps.pushError(
					args[0].getRest() +
						" is not a valid dice number. You must provide a number from 1-6."
				);
				return false;
			}
			return {num};
		},
		src: node => "assets/images/problem-art/dice/" + node.num + ".svg",
		sizeMult: 1.1,
		ratio: 1,
		readAloudText: node => node.num,
	},
	icon: {
		parserDataFunc: function(ps) {
			const data = {};
			const optArg1 = findOptionalArgument(ps);
			const args = findArguments(ps, 1);
			data.color = optArg1 ? optArg1.getRest() : null;
			data.iconName = args[0].getRest().trim();
			return data;
		},
		src: node => getButton(node.iconName, node.color, false),
		sizeMult: 1.5,
		ratio: 1,
		readAloudText: "",
	},
	knight: {
		src: "assets/images/problem-art/chess-knight.svg",
		sizeMult: 1.2,
		ratio: 95 / 148,
		readAloudText: "",
	},
	protractorArrow: {
		src: "assets/images/elements/measurement/rotate-protractor.svg",
		sizeMult: 1,
		ratio: 1,
		readAloudText: "",
	},
	resetIcon: {
		src: "assets/images/icons/reset.svg",
		sizeMult: 1.5,
		ratio: 50 / 42,
		readAloudText: "the reset button",
	},
	redoIcon: {
		src: "assets/images/icons/redo.svg",
		sizeMult: 1.5,
		ratio: 50 / 42,
		readAloudText: "the redo button",
	},
	rulerArrow: {
		src: "assets/images/elements/measurement/rotate-ruler.svg",
		sizeMult: 1,
		ratio: 1,
		readAloudText: "",
	},
	undoIcon: {
		src: "assets/images/icons/undo.svg",
		sizeMult: 1.5,
		ratio: 50 / 42,
		readAloudText: "the undo button",
	},
};

const makeParser = commandType => {
	return function(ps) {
		const nodeData = {
			type: commandType,
			children: [],
		};
		if (commandData[commandType].parserDataFunc) {
			const additionalData = commandData[commandType].parserDataFunc(ps);
			// check for errors and return false if errors found
			if (!additionalData) {
				return false;
			} else {
				_.extend(nodeData, additionalData);
			}
		}
		return [nodeData];
	};
};

const makeNode = commandType => {
	const data = commandData[commandType];
	const measureFunc = data.measureFunc
		? data.measureFunc
		: function(rc, fontInfo, props, node) {
				const imgSubpath = _.isFunction(data.src) ? data.src(node) : data.src;
				const imgSrc = global.BASE_URL + imgSubpath;
				const size = fontInfo.size * data.sizeMult;
				const width = size;
				const ratio = data.ratio;
				const height = width / ratio;
				return {
					width,
					imgSrc,
					top: height / 2,
					bottom: height / 2,
				};
		  };

	return {
		draw(rc, x, y, node, measure) {
			basicDrawNodeImage(rc, x, y, node, measure);
		},
		measure: measureFunc,
		readAloud: data.readAloudText,
	};
};

module.exports = {
	parsers: {
		nonmathCommands: {
			icon: makeParser("icon"),
			knight: makeParser("knight"),
			protractorArrow: makeParser("protractorArrow"),
			redoIcon: makeParser("redoIcon"),
			resetIcon: makeParser("resetIcon"),
			rulerArrow: makeParser("rulerArrow"),
			undoIcon: makeParser("undoIcon"),
		},
		mathCommands: {
			critter: makeParser("critter"),
			dice: makeParser("dice"),
			knight: makeParser("knight"),
			redoIcon: makeParser("redoIcon"),
			resetIcon: makeParser("resetIcon"),
			rulerArrow: makeParser("rulerArrow"),
			undoIcon: makeParser("undoIcon"),
		},
	},
	nodes: {
		critter: makeNode("critter"),
		dice: makeNode("dice"),
		icon: makeNode("icon"),
		knight: makeNode("knight"),
		protractorArrow: makeNode("protractorArrow"),
		redoIcon: makeNode("redoIcon"),
		resetIcon: makeNode("resetIcon"),
		rulerArrow: makeNode("rulerArrow"),
		undoIcon: makeNode("undoIcon"),
	},
};
